import { render, staticRenderFns } from "./UserProfileMenuLeft.vue?vue&type=template&id=1a5b6970&scoped=true&"
import script from "./UserProfileMenuLeft.vue?vue&type=script&lang=js&"
export * from "./UserProfileMenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileMenuLeft.vue?vue&type=style&index=0&id=1a5b6970&scoped=true&lang=css&"
import style1 from "./UserProfileMenuLeft.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b6970",
  null
  
)

export default component.exports